import container from './container.js';
import fontFace from './font-face.js';
import importAtrule from './import.js';
import layer from './layer.js';
import media from './media.js';
import nest from './nest.js';
import page from './page.js';
import scope from './scope.js';
import startingStyle from './starting-style.js';
import supports from './supports.js';

export default {
    container,
    'font-face': fontFace,
    import: importAtrule,
    layer,
    media,
    nest,
    page,
    scope,
    'starting-style': startingStyle,
    supports
};
